import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { StorageService } from 'src/app/core/services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AppData implements OnInit {
  static token = new BehaviorSubject(null);
  static baseUrl = environment.baseUrl;
  static analyticsUrl = environment.analyticsUrl;
  static googleMapUrl = environment.googleMapUrl;
  static paymentBaseUrl = environment.paymentBaseUrl;
  static currency = 'inr';

  static fcmTokenSub$ = new BehaviorSubject(null);
  static fcmToken = '';

  static isAuthenticated = false;

  static userLoginDaySub$ = new BehaviorSubject('');
  static userLoginDay = '';

  static appVersionSub$ = new BehaviorSubject('');
  static appVersion = '';

  static appVersionCodeSub$ = new BehaviorSubject('');
  static appVersionCode = '';

  static userInfoSub$ = new BehaviorSubject(null); // Contain user info object
  static userInfoData = null;

  static userIdSub$ = new BehaviorSubject(null); // Contain user id
  static userId = null;

  static cartIdSub$ = new BehaviorSubject(null); // contain cartId
  static cartId = '';

  static currentAddressSub$ = new BehaviorSubject(null); // contain current address
  static currentAddressObj;

  static firebaseRemoteConfigSub$ = new BehaviorSubject(null); //contain firebase remoteConfig
  static firebaseRemoteConfig = null;

  static searchKeywordsSub$ = new BehaviorSubject('');
  static searchKeywords = [];

  static bottomNavMobileIndSub$ = new BehaviorSubject(0);

  static selectedAddonsListSub$ = new BehaviorSubject([]);
  static selectedAddonsList = [];
  static addonList;

  static yourPlateItemsSub$ = new BehaviorSubject(null);
  static yourPlateItems = null;

  static spInstructionsSub$ = new BehaviorSubject('');
  static spInstructions = '';

  static plateItemCountSub$ = new BehaviorSubject({ itemCount: 0, itemTotal: 0, outletName: '', outletLogo: '', outletId: '' });
  static previousUrl = '';

  static deviceIdSub$ = new BehaviorSubject('');
  static deviceId = '';

  static isTemporarySub$ = new BehaviorSubject(false);
  static isTemporary = false;
  static newUpdateReleased = false;

  static userReferralCodeSub$ = new BehaviorSubject('');
  static userReferralCode = '';

  static deepLinkNavOpt$ = new BehaviorSubject('');
  static deepLinkNavOpt = null;

  static newUpdateReleased$ = new BehaviorSubject(false);
  static navigate = false;
  static deliveryType = '';
  static statusBarHeight = 0;
  static statusBarHeight$ = new BehaviorSubject(0);
  static backButtonInfo$ = new BehaviorSubject(null);
  static bottomNavBarHideOnExplore$ = new BehaviorSubject(false);
  static modalCloseAnimation$ = new BehaviorSubject('');
  static linkedPaytmNumber = '';
  static linkedPaytmNumber$ = new BehaviorSubject(null);
  constructor(private storageService: StorageService) {
  }

  ngOnInit() {
    console.log('App data loaded');
    // for setting current location
    if (this.storageService.getItem("currentLocation") !== null) {
      AppData.currentAddressSub$.next(this.storageService.getItem("currentLocation"));
    }

    AppData.currentAddressSub$.subscribe((res) => {
      this.storageService.setItem("currentLocation", res);
      AppData.currentAddressObj = JSON.parse(JSON.stringify(res));
    });

    if (this.storageService.getItem("token") !== null) {
      AppData.token.next(this.storageService.getItem("token"));
      AppData.isAuthenticated = true;
    }

    AppData.token.subscribe((data: string) => {
      this.setToken(data);
    });

    AppData.fcmTokenSub$.subscribe((data: string) => {
      if (data) {
        AppData.fcmToken = data;
      }
    })

    AppData.appVersionSub$.subscribe((appVersion) => {
      this.storageService.setItem('appVersion', appVersion);
      AppData.appVersion = appVersion;
    });

    AppData.appVersionCodeSub$.subscribe((appVersionCode) => {
      this.storageService.setItem('appVersionCode', appVersionCode);
      AppData.appVersionCode = appVersionCode;
    });

    // for getting user info from local  storage
    if (this.storageService.getItem("userInfo") !== null) {
      AppData.userInfoSub$.next(this.storageService.getItem("userInfo"));
    }

    AppData.userInfoSub$.subscribe((userObj) => {
      this.storageService.setItem("userInfo", userObj);
      AppData.userInfoData = JSON.parse(JSON.stringify(userObj));
      console.log("User Info in App Data", userObj);
    });

    if (this.storageService.getItem("userId") !== null) {
      AppData.userIdSub$.next(this.storageService.getItem("userId"));
    }

    AppData.userIdSub$.subscribe((userId) => {
      this.storageService.setItem("userId", userId);
      AppData.userId = JSON.parse(JSON.stringify(userId));
      console.log("User Id in App Data", userId);
    });

    if (this.storageService.getItem('cartId') !== null) {
      AppData.cartIdSub$.next(this.storageService.getItem('cartId'));
    }

    AppData.cartIdSub$.subscribe((cartId) => {
      this.storageService.setItem('cartId', cartId);
      AppData.cartId = cartId;
    });

    if (this.storageService.getItem('isTemporary') !== null) {
      AppData.isTemporarySub$.next(this.storageService.getItem('isTemporary'));
    }

    AppData.isTemporarySub$.subscribe((isTemporary) => {
      this.storageService.setItem('isTemporary', isTemporary);
      if (isTemporary) {
        AppData.isTemporary = true;
      } else {
        AppData.isTemporary = false;
      }
    })


    if (this.storageService.getItem("firebaseRemoteConfig") !== null) {
      AppData.firebaseRemoteConfigSub$.next(this.storageService.getItem("firebaseRemoteConfig"));
    }

    AppData.firebaseRemoteConfigSub$.subscribe((firebaseRemoteConfig) => {
      this.storageService.setItem("firebaseRemoteConfig", firebaseRemoteConfig);
      AppData.firebaseRemoteConfig = JSON.parse(JSON.stringify(firebaseRemoteConfig));
      console.log("RemoteConfig in App Data", firebaseRemoteConfig);
    });


    if (this.storageService.getItem('yourPlateItem') !== null) {
      AppData.yourPlateItemsSub$.next(this.storageService.getItem('yourPlateItem'));
    }

    AppData.yourPlateItemsSub$.subscribe((plateObj) => {
      this.storageService.setItem('yourPlateItem', plateObj);
      AppData.yourPlateItems = JSON.parse(JSON.stringify(plateObj));
      if (AppData.yourPlateItems) {
        let itmCount = 0;
        let itemsInPlate = 0;
        if (AppData.yourPlateItems['outlets'].length > 0) {
          itemsInPlate = AppData.yourPlateItems['outlets'][0]['items'].length;
        }
        let itmSubTotal = 0
        if (itemsInPlate > 0) {
          AppData.yourPlateItems['outlets'][0]['items'].forEach((items) => {
            itmCount += items.quantity;
            itmSubTotal += items.billing.subTotal;
          });
          AppData.plateItemCountSub$.next({
            itemCount: itmCount, itemTotal: itmSubTotal, outletName: plateObj['outlets'][0]['outletName'],
            outletLogo: plateObj['outlets'][0]['outletLogo'], outletId: plateObj['outlets'][0]['outletId']
          });
        } else {
          AppData.plateItemCountSub$.next({ itemCount: 0, itemTotal: 0, outletName: '', outletLogo: '', outletId: '' });
        }
      }
    });

    if (this.storageService.getItem('searchKeywords')) {
      // AppData.searchKeywordsSub$.next(this.storageService.getItem('searchKeywords'));
      AppData.searchKeywords = JSON.parse(JSON.stringify(this.storageService.getItem('searchKeywords')));
    }

    AppData.searchKeywordsSub$.subscribe((keyword) => {
      console.log('keyword:', keyword);
      let keywords = JSON.parse(JSON.stringify(this.storageService.getItem('searchKeywords')));
      if (keywords == null) {
        keywords = [];
      } else {
        if (keywords.indexOf(keyword) < 0 && keyword !== '') {
          keywords.splice(0, 0, keyword);
          keywords = keywords.slice(0, 5);
        }
      }
      this.storageService.setItem('searchKeywords', keywords);
      AppData.searchKeywords = JSON.parse(JSON.stringify(keywords));
    });

    if (this.storageService.getItem('selectAddonsList')) {
      AppData.selectedAddonsListSub$.next(this.storageService.getItem('selectAddonsList'));
    }

    AppData.selectedAddonsListSub$.subscribe((addons) => {
      this.storageService.setItem('selectAddonsList', addons);
      AppData.selectedAddonsList = JSON.parse(JSON.stringify(addons));
    });

    if (this.storageService.getItem('spInstructions')) {
      AppData.spInstructionsSub$.next(this.storageService.getItem('spInstructions'));
    }

    AppData.spInstructionsSub$.subscribe((spl) => {
      console.log('splIns---->', spl);
      this.storageService.setItem('spInstructions', spl);
      AppData.spInstructions = JSON.parse(JSON.stringify(spl));
    });

    if (this.storageService.getItem("deviceId") !== null) {
      AppData.deviceIdSub$.next(this.storageService.getItem("deviceId"));
    }

    AppData.deviceIdSub$.subscribe((deviceId) => {
      this.storageService.setItem("deviceId", deviceId);
      AppData.deviceId = JSON.parse(JSON.stringify(deviceId));
      console.log("deviceId", deviceId);
    });

    if (this.storageService.getItem('userReferralCode') !== null) {
      AppData.userReferralCodeSub$.next(this.storageService.getItem('userReferralCode'));
    }

    AppData.userReferralCodeSub$.subscribe((referralCode) => {
      this.storageService.setItem("userReferralCode", referralCode);
      AppData.userReferralCode = JSON.parse(JSON.stringify(referralCode));
    });

    AppData.statusBarHeight$.subscribe((value) => {
      if (value) {
        AppData.statusBarHeight = value;
      }
    })
    if (this.storageService.getItem('linkedPaytmNumber') !== null) {
      AppData.linkedPaytmNumber$.next(this.storageService.getItem("linkedPaytmNumber"));
    }
    AppData.linkedPaytmNumber$.subscribe((number) => {
      this.storageService.setItem("linkedPaytmNumber", number);
      AppData.linkedPaytmNumber = number;
    });

  }

  setToken(token: string) {
    this.storageService.setItem("token", token);
    console.log("token set");
  }

  isAuthenticatedFunction() {
    return !(this.storageService.getItem("token") === null);
  }
}
